import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-becario',
  templateUrl: './footer-becario.component.html',
  styleUrls: ['./footer-becario.component.css']
})
export class FooterBecarioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
